/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BulkStateUpdateDTO { 
    stepName: string;
    updateSelf?: boolean;
    reasonForRejection?: string;
    attachments?: Array<string>;
    tempStepId?: number;
    objectIdType?: string;
}

